module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-plus.09ea5ced.svg";